'use client';
import { createStyles, rem } from '@s7/styles';

var useStyles = createStyles(function(theme, param) {
    var width = param.width, height = param.height, fit = param.fit;
    var _obj;
    return {
        root: {},
        image: {
            objectFit: fit,
            width: !width ? "100%" : undefined,
            height: !height ? "100%" : undefined
        },
        fallback: (_obj = {
            background: theme.palette.background.element,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: width ? rem(width) : "100%",
            height: height ? rem(height) : "100%"
        }, _obj['&[data-fallback="placeholder"]'] = {
            background: "transparent"
        }, _obj)
    };
});

export { useStyles as default };
